import React from 'react';
import type { ProvinceCalculatorPageConfig } from '../../config/provinceCalculatorPages';
import { ProvinceClosingCostsBreakdown } from './ProvinceClosingCostsBreakdown';

interface ProvinceCalculatorExtrasProps {
  config: ProvinceCalculatorPageConfig;
}

/** Below-the-fold province content; lazy-loaded so the calculator chrome can paint first. */
export const ProvinceCalculatorExtras: React.FC<ProvinceCalculatorExtrasProps> = ({ config }) => {
  const { ContextContent } = config;

  return (
    <>
      <ProvinceClosingCostsBreakdown
        provinceId={config.id}
        tabIsToronto={config.tabIsToronto}
      />

      <section id="province-context" className="px-6 py-8 border-t border-stone-border/80 scroll-mt-32">
        <h2 className="font-serif text-2xl text-ink mb-6">{config.contextNavLabel}</h2>
        <ContextContent />
      </section>
    </>
  );
};
